export default [
    {
        "fa": "fab fa-facebook",
        "value": "Facebook",
        "linkTo": "  https://www.facebook.com/HoustonMedImaging"
    },
    {
        "fa": "fab fa-instagram",
        "value": "Instagram",
        "linkTo": "https://www.instagram.com/houstonmedimaging"
    },
    {
        "fa": "fa-brands fa-threads",
        "value": "Threads",
        "linkTo": "https://www.threads.net/@houstonmedimaging"
    },
    {
        "fa": "fab fa-linkedin",
        "value": "Linkedin",
        "linkTo": " https://www.linkedin.com/company/houstonmedimaging"
    },
    {
        "fa": "fa-brands fa-x-twitter",
        "value": "Twitter",
        "linkTo": "https://x.com/houstonmedimage"
    },
    {
        "fa": "fab fa-tiktok",
        "value": "TikTok",
        "linkTo": "https://www.tiktok.com/@houstonmedimaging"
    },
    {
        "fa": "fab fa-youtube",
        "value": "YouTube",
        "linkTo": "https://www.youtube.com/@houstonmedimaging"
    },
    {
        "fa": "fas fa-microphone",
        "value": "Your Body Podcast",
        "linkTo": "https://www.yourbodyshow.com/?utm_source=rad_link&utm_medium=radnet_family_websites&utm_campaign=your_body_show"
    },
    {
        "fa": "fas fa-file",
        "value": "Self Requesting Screening Mammograms",
        "linkTo": "https://docs.google.com/document/d/13fws131wHGCvsC3v_qUhmsEtF_ALvQwvvh21zTJ-FgQ/edit?usp=sharing"
    },
    {
        "fa": "fas fa-globe",
        "value": "Our Website",
        "linkTo": "https://hmixray.com/"
    },
    {
        "fa": "fa fa-briefcase",
        "value": "Careers",
        "linkTo": "https://careers.radnet.com/careers-home/"
    }
]